<div class="inner-card flow-root column dis-block">
    <div fxLayout="row wrap" fxLayoutGap="20px" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100">

        <div fxFlex.gt-sm="18" fxFlexAlign="center" id="action-selection-period-type">
            <mat-radio-group aria-label="Select an option" layout="row" [(ngModel)]="radioSelected"
                (ngModelChange)="SetFilterValues('PeriodRadio')">
                <mat-radio-button value="0" class="md-primary">Actuacion</mat-radio-button>
                <mat-radio-button value="1">Registro</mat-radio-button>
            </mat-radio-group>
        </div>

        <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Common"
            [PeriodFrom]="CommonDateFrom" [PeriodTo]="CommonDateTo"
            (FromDateChanged)="SetFilterValues('commonDateFrom', $event)"
            (ToDateChanged)="SetFilterValues('commonDateTo', $event)"></app-date-period-filter>

        <div class="mr-20" fxFlex.gt-sm="13" fxFlexAlign="center" id="action-selection-active-leaves">
            <mat-checkbox [(ngModel)]="ActiveLeaves" (ngModelChange)="SetFilterValues('activeLeaves')">Sólo bajas
                activas</mat-checkbox>
        </div>

        <div class="mr-20" fxFlex.gt-sm="13" fxFlexAlign="center" id="action-selection-empresa-selec">
            <mat-checkbox [(ngModel)]="EmpresaSelec" (ngModelChange)="SetFilterValues('empresaSelec')">Solo empresa seleccionada
            </mat-checkbox>
        </div>

        <mat-form-field >
            <mat-label>Orden</mat-label>
            <mat-select class="full-width-multi-select" [(ngModel)]="Orden" (ngModelChange)="SetFilterValues('Orden')">
                <mat-option *ngFor="let orden of OrdenList$" [value]="orden.value">{{orden.text}}</mat-option>
            </mat-select>
        </mat-form-field>

        <app-globle-author *ngIf="selectionService.selectionPermissions.HasPermisos510" [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')"  [moduleName]="responsibleModuleName"  [authorTypes]="responsibleAuthorTypes" (AutorChanged)="onChangeAutor('Autor',$event)" (UserChanged)="onChangeAutor('User',$event)"
        (MedicoChanged)="onChangeAutor('Medico',$event)" (CoordinatorChanged)="onChangeAutor('Coordinator',$event)">
        </app-globle-author>

        <!-- <app-autor-filter (AutorChanged)="onChangeAutor('Autor',$event)" (UserChanged)="onChangeAutor('User',$event)"
            (MedicoChanged)="onChangeAutor('Medico',$event)" (CoordinatorChanged)="onChangeAutor('Coordinator',$event)"
            *ngIf="selectionService.selectionPermissions.HasPermisos510" class="actuation-autor-filter">
        </app-autor-filter> -->

        <mat-slide-toggle *ngIf="isShowRevisar && selectionService.selectionPermissions.HasPermisos208"
            [(ngModel)]="filterService.IsRevisor" (ngModelChange)="SetFilterValues('IsRevisor')">Revisar
        </mat-slide-toggle>
        <app-employee-filter></app-employee-filter>

        <mat-form-field *ngIf="filterService.IsRevisor && selectionService.selectionPermissions.HasPermisos208">
            <mat-label>Coordinador</mat-label>
            <mat-select class="full-width-multi-select" [(ngModel)]="Coordinator"
                (ngModelChange)="SetFilterValues('Coordinator')">
                <mat-option *ngFor="let Coordinator of CoordinatorList$" [value]="Coordinator.viewValue">
                    {{Coordinator.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>